<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : 'bg-nav navbar-dark'"
    type
  >
    <!-- Navbar links -->
    <ul class="navbar-nav align-items-center ml-md-auto">
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-3 sidenav-toggler sidenav-toggler-dark" @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>
    </ul>
    <div class="align-navbar-header">
      <div class="media-body mr-2">
        <span class="mr-1"><i class="fa fa-home"></i></span>
        <span class="btn-inner--text catering-name" v-if="user.catering">{{ user.catering.name }}</span>
      </div>

      <div class="d-flex align-items-center">
        <portal-updates-bell @open="$emit('open-portal-update', $event)" />
        <base-dropdown menuOnRight>
          <base-button slot="title-container" type="secondary" class="dropdown-toggle btn-nav align-items-end">
            <div class="media align-items-center">
              <div class="media-body mr-2 d-none d-lg-block">
                <span class="mb-0 text-rol">&nbsp;<strong v-if="user.rol"></strong>{{ user.name }}&nbsp;</span>
              </div>
              <span class="avatar avatar-sm rounded-circle">
                <img alt="Image placeholder" src="/img/avatar.png"/>
              </span>
            </div>
          </base-button>
          <a class="dropdown-item" href="#" @click="logout">Cerrar sesión</a>
        </base-dropdown>
      </div>
    </div>
  </base-nav>
</template>

<script>
import { BaseNav } from '@/components';
import PortalUpdatesBell from '@/components/PortalUpdates/PortalUpdatesBell.vue';
import axios from 'axios';

export default {
  components: {
    BaseNav,
    PortalUpdatesBell,
  },
  computed: {
    isRTL() {
      return this.$rtl.isRTL;
    },
  },
  data() {
    return {
      showMenu: false,
      user: { name: '' },
    };
  },
  async created() {
    await this.getUser();
  },
  methods: {
    async getUser() {
      try {
        const resp = await axios.get('auth/me');
        this.user = resp.data;
      } catch (e) {
        console.error('Error cargando usuario:', e);
      }
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logout() {
      axios.delete('/auth/logout');
      this.$store.dispatch('LOGOUT');
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-secondary {
  background-color: transparent;
  border: none;
  box-shadow: none;
  padding: 0;

  &:after {
    display: none;
  }
}

.catering-name {
  color: #676769;
  font-family: 'Axiforma';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140%;
}

.align-navbar-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-content: flex-start;
  align-items: center;
}
</style>
